import * as React from 'react';
const SvgCircleSmall = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M22 12c0 5.525-4.475 10-10 10-5.523 0-10-4.475-10-10S6.477 2 12 2c5.525 0 10 4.475 10 10ZM12 5c-3.866 0-7 3.131-7 7s3.134 7 7 7c3.869 0 7-3.131 7-7s-3.131-7-7-7Z", fill: "currentColor" })));
export default SvgCircleSmall;
